import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "mobx-react"
import stores from "app/stores"
import { getTokenBundle } from "app/api/localTools"
import { startRefresher } from "app/vendor/util"
import { ThemeProvider } from 'styled-components'
import { BrowserRouter } from 'react-router-dom'

if (window.location.href.indexOf("login") < 0 && getTokenBundle()) {
  startRefresher()
}

const theme = {
  primary: 'rgb(40, 108, 172)',
  // lightBlue: 'rgb(100, 182, 255)',
  linearGradientToLeft: 'linear-gradient(to left, rgb(94, 119, 255), rgb(0, 177, 255))',
  transitionBtn: 'all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)',
  semibold: 'PingFangSC-Semibold',
  regular: 'PingFangSC-Regular',
  light: 'PingFangSC-Light',
  transitionExpand: 'max-height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)',
}

function init () {
  let App = require("app").default
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <Provider {...stores}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ThemeProvider>,
    document.getElementById("root")
  )
}

if (module.hot) {
  module.hot.accept("app", () => requestAnimationFrame(init))
}

init()



// WEBPACK FOOTER //
// ./src/index.js